<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="提现记录" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
				<div  class="common-btn btn" slot="right" @click="addWithdraw">新增</div>
            </mt-header>
        </div>
        <div class="mt-5" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="item mb-5" v-for="item in logList" :key="item.o2o_fuwu_order_log_id">
                <div class="mt-wrapper">
                    <div class="mt">
                        <h2>可用资金：{{item.o2o_fuwu_organization_avaliable_money}}</h2>
                    </div>
                    <div class="mt">
                        <h2>冻结资金：{{item.o2o_fuwu_organization_freeze_money}}</h2>
                    </div>
                </div>
                <div class="mc">
                    {{item.o2o_fuwu_money_log_desc}}
                </div>
                <div class="time"> {{ $moment.unix(item.o2o_fuwu_money_log_add_time).format('YYYY-MM-DD h:mm:ss') }}</div>
            </div>
            <empty-record v-if="logList && !logList.length"></empty-record>
        </div>
    </div>
</template>

<script>
import { Indicator, MessageBox, Toast } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getWithdrawList, addWithdraw } from '../../../api/fuwuManageMoney'
export default {
  name: 'LogList',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      logList: false // 记录列表
    }
  },
  methods: {
    // 申请提现
    addWithdraw () {
      let _this = this
      MessageBox.prompt('请输入提现金额', '',{closeOnClickModal:false}).then(({ value, action }) => {
        addWithdraw(value).then(res => {
          this.getLogList(false)
          Toast(res.message)
        }).catch(function (error) {
          if (error.code == 30002) {
            Toast(error.message)
            _this.$router.push({ name: 'FuwuManageInfoOperate' })
          } else {
            Toast(error.message)
          }
        })
      })
    },
    getLogList (ispush) {
      Indicator.open()
      let params = this.params
      getWithdrawList(params).then(res => {
        Indicator.close()

        if (ispush && this.logList) {
          this.logList = this.logList.concat(res.result.log_list)
        } else {
          this.logList = res.result.log_list
        }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getLogList(true)
      }
    }
  }
}
</script>

<style scoped>
	.common-header{
	    .btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
	}
    .item{padding:.5rem;background:#fff;}
    .item .mt-wrapper{display: flex}
    .item .mt{height:2rem;line-height:2rem;flex:1}
    .item .mt h2{font-weight:bold;font-size:.7rem}
    .item .time{font-size:.6rem;color:gray}
    .item .mc{padding-top:.5rem;line-height:1rem;font-size:.8rem;}
</style>
